// Per-app landing copy for Google. Catalog fields in gamesData.js still win
// when factory sync writes seoTitle / keywords / description.
const appLanding = {
  "voice-judge": {
    seoTitle: "Voice Judge: Choicer Voicer App",
    seoDescription:
      "Voice Judge is a Dub Scenes app for iPhone and Android. Dub original scenes with friends, get scored on timing and energy, and compete on one phone.",
    keywords: [
      "Choicer Voicer App",
      "Voice Judge: Choicer Voicer App",
      "Dub Scenes App",
      "Voice Judge App",
      "scene dubbing game",
      "Voice Judge: Dub Scenes",
    ],
    description:
      "Voice Judge is a Dub Scenes app — a pass-the-phone party game where you step into a scene, perform the line, and get judged. Import your own short clips or try optional public-domain scenes, mute the original dialogue, and score timing, energy, and delivery with friends.\n\nPeople looking for a Choicer Voicer app on iPhone or Android use Voice Judge to dub scenes, pass the phone, and find out who gave the best performance. No karaoke accounts or licensed song catalogs required.",
    features: [
      "1–4 players on one phone with a this-session leaderboard",
      "Scene Dub and Cast Battle modes",
      "Fair Judge scores for timing, energy, and delivery",
      "Import 5–60 second clips from Photos",
      "On-device audio — clips never leave the phone",
    ],
    faq: [
      {
        q: "What is the Voice Judge Dub Scenes app?",
        a: "Voice Judge is a scene-dubbing party game. You watch a reference, perform the dialogue, and get a score — then pass the phone so friends can compete.",
      },
      {
        q: "Is Voice Judge a Choicer Voicer app for iPhone?",
        a: "Voice Judge is MindBlows’ Dub Scenes app for iPhone and Android. If you are searching for a Choicer Voicer app on phones, Voice Judge is the scene-dubbing party game you can download today.",
      },
      {
        q: "Is Voice Judge free?",
        a: "Yes. Voice Judge is free on the App Store and Google Play. Optional Judge Pro unlocks extra packs, Live Dub, and ad-free rounds.",
      },
    ],
  },
  tangens: {
    seoTitle: "Tangens: UV Index & Tan Timer App",
    seoDescription:
      "Tangens is a UV Index and Tan Timer app. See today’s UV, minutes until burn risk, and a guided tanning routine matched to your skin type and SPF.",
    keywords: [
      "Tan Timer",
      "UV Index",
      "UV Index App",
      "Tan Timer App",
      "Tangens App",
      "UV index tan timer",
    ],
    description:
      "Tangens is a UV Index and Tan Timer app that helps you plan safer outdoor sun time. Check today’s UV number, the hourly curve, peak time, and a burn-risk estimate for your skin type and SPF — then start a guided tanning routine with timed front and back rounds.\n\nInstead of guessing how long to stay out, the tan timer follows a sunscreen step, exposure rounds, and a shade break so vitamin D or tanning sessions stay on a schedule.",
    features: [
      "Live UV dashboard: current index, hourly curve, peak, sunrise to sunset",
      "Burn-risk minutes based on skin type and SPF",
      "Guided tan timer with sunscreen, front/back rounds, and shade break",
      "Vitamin D and UV exposure cards",
      "10-day UV forecast with Tangens Pro",
    ],
    faq: [
      {
        q: "What is the Tangens UV Index app?",
        a: "Tangens shows today’s UV index for your location, how long you can stay outside, and a guided routine matched to your skin and SPF.",
      },
      {
        q: "Does Tangens include a tan timer?",
        a: "Yes. Tangens is a tan timer app: start a session and follow timed front and back rounds plus a shade break, instead of watching a raw UV number.",
      },
      {
        q: "Is Tangens free?",
        a: "Yes. Tangens is free on the App Store and Google Play. Tangens Pro adds a 10-day UV forecast, extra skin presets, and an ad-free experience.",
      },
    ],
  },
  "flip-verse": {
    seoTitle: "Flip Verse: Reverse Singing App",
    seoDescription:
      "Flip Verse is a reverse singing app. Record a line, hear it backward, learn the reverse take, and share the flip.",
    keywords: [
      "Reverse Singing App",
      "Flip Verse App",
      "reverse singing",
      "backwards singing app",
    ],
    description:
      "Flip Verse is a reverse singing app for recording a line, flipping it backward, and practicing the reversed take until you can sing it. Share the result with friends without needing a full DAW.",
    features: [
      "Record and reverse your voice",
      "Practice the backward take",
      "Share the flipped clip",
    ],
  },
  "room-act": {
    seoTitle: "Room Act: Party Charades App",
    seoDescription:
      "Room Act is a party charades app. Act it out on one phone and let friends guess — no cards, no extra hardware.",
    keywords: [
      "Party Charades App",
      "Room Act App",
      "charades app",
      "acting party game",
    ],
    description:
      "Room Act is a party charades app for groups. One player acts the prompt while everyone else guesses, using a pass-the-phone round that works at a table or on the couch.",
    features: [
      "Pass-the-phone charades rounds",
      "Built for groups of friends",
      "No extra cards or packs required to start",
    ],
  },
  "driving-theory": {
    seoTitle: "Driving Theory Test 2026 App",
    seoDescription:
      "Practice driving theory and Life in the UK test questions in a 2026 theory test app with revision-style quizzes.",
    keywords: [
      "Driving Theory Test 2026",
      "theory test app",
      "Life in the UK test",
      "driving theory app",
    ],
    description:
      "Driving Theory Test 2026 is a revision app for driving theory and Life in the UK-style questions. Drill topics, review explanations, and practice before you sit a real test.",
    features: [
      "Driving theory practice questions",
      "Life in the UK test practice",
      "Review and retry missed items",
    ],
  },
  "migraine-tracker": {
    seoTitle: "Migraine & Headache AI Tracker App",
    seoDescription:
      "A private migraine and headache attack tracker with AI insights. Log attacks, symptoms, and patterns on your phone.",
    keywords: [
      "Migraine Tracker App",
      "headache tracker",
      "migraine log",
      "headache diary app",
    ],
    description:
      "Migraine & Headache AI Tracker is a private attack log for migraines and headaches. Record what happened, spot patterns over time, and keep the diary on your device.",
    features: [
      "Log migraine and headache attacks",
      "Track symptoms and patterns",
      "Private, on-device diary",
    ],
  },
  "pass-photo": {
    seoTitle: "Pass Photo: Passport ID Size App",
    seoDescription:
      "Crop passport and ID photos to official size and print sheets. A passport photo app that stays on your phone.",
    keywords: [
      "Passport Photo App",
      "Pass Photo App",
      "ID photo size",
      "passport photo crop",
    ],
    description:
      "Pass Photo is a passport and ID photo app. Crop a picture to official sizes, preview the result, and export print sheets without a studio visit.",
    features: [
      "Official passport and ID crop sizes",
      "Print-ready sheets",
      "On-device editing",
    ],
  },
  "code-snap": {
    seoTitle: "Code Snap: QR Generator App",
    seoDescription:
      "Generate Wi-Fi, URL, and contact QR codes on your phone. Static codes that keep working — no account required.",
    keywords: [
      "QR Generator App",
      "Code Snap App",
      "Wi-Fi QR code",
      "QR code generator",
    ],
    description:
      "Code Snap is a QR generator app for Wi-Fi, URLs, phone, email, and vCard contact codes. Codes are generated on the device so printed QR codes do not depend on a subscription staying active.",
    features: [
      "URL, text, phone, email, Wi-Fi, and vCard codes",
      "Live preview before export",
      "Save PNG or share instantly",
    ],
  },
  "level-snap": {
    seoTitle: "Level Snap: Bubble Level App",
    seoDescription:
      "A bubble level app for hanging pictures and shelves straight. Live level readout on your phone.",
    keywords: [
      "Bubble Level App",
      "Level Snap App",
      "spirit level app",
      "picture hanging level",
    ],
    description:
      "Level Snap is a bubble level app for hanging frames and shelves. Use the live level to get a straight line without a separate spirit level.",
    features: [
      "Live bubble level",
      "Built for hanging pictures and shelves",
      "Works on your phone — no extra tool",
    ],
  },
  "eretz-ir": {
    seoTitle: "ארץ עיר — משחק קטגוריות",
    seoDescription:
      "ארץ עיר הקלאסי על הסמארטפון. מלאו קטגוריות לפי אות, שעון, ונקודות מול חברים.",
    keywords: ["ארץ עיר", "ארץ עיר אפליקציה", "משחק קטגוריות", "Eretz Ir"],
    description:
      "ארץ עיר הוא משחק הקטגוריות הקלאסי בנייר — עכשיו על הטלפון. בחרו אות, מלאו ערים, שמות ומדינות, והשוו נקודות עם חברים.",
    features: [
      "המשחק הקלאסי בפורמט נייד",
      "משחק עם חברים",
      "עברית מלאה",
    ],
  },
  dusty: {
    seoTitle: "Dusty: AI Storage Cleaner App",
    seoDescription:
      "Dusty is an AI storage cleaner that finds duplicates and frees space on iPhone.",
    keywords: [
      "AI Storage Cleaner",
      "Dusty App",
      "duplicate photo cleaner",
      "iPhone storage cleaner",
    ],
    description:
      "Dusty is an AI storage cleaner for finding duplicate and bulky files so you can free space without deleting everything by hand.",
    features: [
      "Find duplicates and large files",
      "Free up storage",
      "Review before you delete",
    ],
  },
  pups: {
    seoTitle: "Pups: Daily Routine & Habits App",
    seoDescription:
      "Daily routines and habits for kids. A simple routine app families can follow together.",
    keywords: [
      "kids routine app",
      "Pups App",
      "habits for kids",
      "daily routine kids",
    ],
    description:
      "Pups is a daily routine and habits app for kids. Build a simple checklist kids can follow for mornings, evenings, and everyday tasks.",
    features: [
      "Kid-friendly daily routines",
      "Habit checklists",
      "Made for families",
    ],
  },
  blackjack: {
    seoTitle: "Blackjack 3D: 21 Casino Game",
    seoDescription:
      "Play classic 21 blackjack in an immersive 3D casino game on Android.",
    keywords: ["Blackjack 3D", "21 casino game", "blackjack app", "casino blackjack"],
    description:
      "Blackjack 3D is a classic 21 casino game in immersive 3D. Play blackjack rounds with 3D tables and familiar casino rules.",
    features: ["Classic 21 blackjack", "Immersive 3D tables", "Casino-style rounds"],
  },
  poker: {
    seoTitle: "Poker 3D: Casino Game",
    seoDescription:
      "Texas hold’em poker in an immersive 3D casino game on Android.",
    keywords: ["Poker 3D", "Texas hold'em app", "casino poker game", "poker app"],
    description:
      "Poker 3D is a Texas hold’em casino game in immersive 3D. Play poker hands at a 3D table without a live-dealer account.",
    features: ["Texas hold’em", "Immersive 3D table", "Casino-style play"],
  },
  "cue-scroll": {
    seoTitle: "Cue Scroll: Teleprompter App",
    seoDescription:
      "Cue Scroll is a teleprompter app for reading a script on camera with adjustable scroll speed.",
    keywords: [
      "Teleprompter App",
      "Cue Scroll App",
      "script teleprompter",
      "prompter for phone",
    ],
    description:
      "Cue Scroll is a teleprompter app for reading a script on camera. Load your lines, set the scroll speed, and record looking at the lens instead of a paper script.",
    features: [
      "On-camera script scroll",
      "Adjustable speed",
      "Built for talking-head recording",
    ],
  },
  "stud-peak": {
    seoTitle: "Stud Peak: Wall Stud Finder App",
    seoDescription:
      "Stud Peak is a wall stud finder app with a live microtesla magnetic scan on your phone.",
    keywords: [
      "Wall Stud Finder",
      "Stud Peak App",
      "stud finder app",
      "magnetic stud scanner",
    ],
    description:
      "Stud Peak is a wall stud finder app that uses a live microtesla scan to help locate metal in walls before you drill. Use it as a phone-based stud finder, not a replacement for a dedicated scanner in every wall type.",
    features: [
      "Live microtesla scan",
      "Help locate metal in walls",
      "Phone-based stud finder",
    ],
  },
  "flag-quiz": {
    seoTitle: "Flag Quiz: Country Trivia App",
    seoDescription:
      "Guess countries from their flags in a flag quiz and country trivia app.",
    keywords: [
      "Flag Quiz App",
      "country trivia",
      "flags of the world quiz",
      "geography quiz app",
    ],
    description:
      "Flag Quiz is a country trivia app. See a flag, guess the country, and learn flags of the world in short quiz rounds.",
    features: ["Flag recognition quizzes", "Countries of the world", "Short trivia rounds"],
  },
  volcano: {
    seoTitle: "Volcano: Tropical Word Game",
    seoDescription:
      "Tropical word search puzzles in English and Hebrew. A word game app with volcanic themed boards.",
    keywords: [
      "Volcano word game",
      "word search app",
      "Hebrew word search",
      "tropical word puzzle",
    ],
    description:
      "Volcano is a tropical word search game in English and Hebrew. Find words on themed boards in short puzzle sessions.",
    features: [
      "Word search puzzles",
      "English and Hebrew",
      "Tropical-themed boards",
    ],
  },
  sucaryot: {
    seoTitle: "סוכריות — תשחץ מהעתיד",
    seoDescription: "אלפי תשבצים בעברית. תשחץ מהעתיד — משחק מילים קלאסי על הטלפון.",
    keywords: ["סוכריות", "תשחץ", "תשבץ עברית", "word candy hebrew"],
    description:
      "סוכריות הוא תשחץ מהעתיד עם אלפי תשבצים בעברית. משחק מילים קלאסי שמותאם לנייד.",
    features: ["אלפי תשבצים בעברית", "משחק מילים קלאסי", "מותאם לנייד"],
  },
  "tricky-quiz": {
    seoTitle: "המבחן — חידות וחידון",
    seoDescription: "חידות מאתגרות שיבדקו כמה אתם באמת חכמים. משחק חידון בעברית.",
    keywords: ["המבחן", "חידות", "חידון עברית", "tricky quiz"],
    description:
      "המבחן הוא משחק חידות מאתגר בעברית. שאלונים קצרים שבודקים כמה אתם באמת חכמים.",
    features: ["חידות מאתגרות", "חידון בעברית", "סבבים קצרים"],
  },
  "sucaryot-kids": {
    seoTitle: "סוכריות קידס",
    seoDescription: "גרסת ילדים של משחק סוכריות — תשבצים בעברית לילדים.",
    keywords: ["סוכריות קידס", "תשבץ ילדים", "משחק מילים לילדים"],
    description:
      "סוכריות קידס היא גרסת הילדים של סוכריות: תשבצים בעברית שמותאמים לגיל צעיר יותר.",
    features: ["תשבצים לילדים", "עברית", "משחק מילים"],
  },
  "truth-or-dare-2": {
    seoTitle: "Truth or Dare 2 Party Game",
    seoDescription:
      "The ultimate truth or dare party game for friends. Pass the phone and play.",
    keywords: [
      "Truth or Dare 2",
      "truth or dare app",
      "party game for friends",
      "truth or dare party",
    ],
    description:
      "Truth or Dare 2 is a party game for friends. Pass the phone, pick truth or dare, and keep the round going without a card deck.",
    features: [
      "Truth and dare prompts",
      "Built for groups of friends",
      "Pass-the-phone party rounds",
    ],
  },
};

export default appLanding;
